import api from '../axios';

export const GET_ALL_PAYMENT_TYPES = 'GET_ALL_PAYMENT_TYPES'

export const getAllPaymentTypes = () => (dispatch) => {
    let options = {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
    };
    return api.get('/paymenttypes' + '?size=300', options)
        .then((response) => {
            dispatch({ type: GET_ALL_PAYMENT_TYPES, payload: response.data})
            return Promise.resolve(response.data)
        })
        .catch((error) => {
            return Promise.reject(error.response.data.error)
        })
}
